/* eslint-disable eqeqeq */
import {Field, useFormikContext} from 'formik'
import {useEffect, useState} from 'react'
import Flatpickr from 'react-flatpickr'
import Select, {components} from 'react-select'

import 'flatpickr/dist/themes/airbnb.css'

import moment from 'moment'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import {isValidMail, isValidString} from 'src/_metronic/helpers/FieldValidator'
import PhoneNumberInput from 'src/app/modules/phoneNumberInput'
import getCities from 'src/feature/become-merchant/services/getCities'
import getCountries from 'src/feature/become-merchant/services/getCountries'
import getRegions from 'src/feature/become-merchant/services/getRegionsByCity'

interface ColumnType {
  title: string
  tooltip?: string
  required?: boolean
  dataIndex: any
  key: string
  displayType?: string
  render?: (text: string, data: ColumnType) => JSX.Element
  status?: boolean
  yesOrNo?: boolean
  valueSelect?: boolean
  edit?: string
  maxLength?: number
  colWidth?: number
  regex?: string
  formName?: string
  selects?: {value: any; text: string; disabled?: boolean}[]
  setSelectedCategoryID?: any
  onChange?: any
}

interface TableProps {
  loading?: boolean
  columns: ColumnType[][]
  dataSource: any
  editable?: boolean
  values?: any
}

function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') // $& string'in tamamını ifade eder.
}

export default function InlineTable({loading, columns, dataSource, editable, values}: TableProps) {
  const {errors, touched, setTouched, setFieldValue} = useFormikContext()
  const [isLoading, setIsLoading] = useState(false)

  const [list, setList] = useState<{countries: any[]; cities: any[]; regions: any[]; iso: []}>({
    countries: [],
    cities: [],
    regions: [],
    iso: [],
  })

  useEffect(() => {
    if (!editable || !values) return
    setIsLoading(true)

    getCountries()
      .then((countries) => {
        if (!countries) return

        const country = countries.find((country) => country.id === values.countryID)

        getCities(country?.id || countries[0].id).then((cities) => {
          const city = cities.find((city) => city.id === values.cityID)

          getRegions(city?.id || cities?.[0]?.id).then((regions) => {
            setFieldValue('countryID', country?.id || countries?.[0]?.id || '')
            setFieldValue('cityID', city?.id || cities?.[0]?.id || '')

            setList({...list, countries, cities, regions})
          })
        })
      })
      .catch((err) => {
        setIsLoading(false)
        console.log(err)
      })

    setIsLoading(false)
  }, [editable])

  useEffect(() => {
    if (!editable || !values || !values.countryID) return
    setIsLoading(true)

    getCities(values.countryID)
      .then((cities) => {
        // setList({ ...list, cities: res });
        getRegions(cities[0].id).then((regions) => {
          setFieldValue('cityID', cities[0].id || '')

          setList({...list, cities, regions})
        })
      })
      .catch((err) => {
        setIsLoading(false)
        console.log(err)
      })

    setIsLoading(false)
  }, [values?.countryID])

  useEffect(() => {
    if (!editable || !values || !values.cityID) return
    setIsLoading(true)

    getRegions(values.cityID)
      .then((regions) => {
        setList({...list, regions})
      })
      .catch((err) => {
        setIsLoading(false)
      })

    setIsLoading(false)
  }, [values?.cityID])

  const statusCheck = (input: any) => {
    let text = 'Passive'
    let boolen = true

    switch (input) {
      case true:
        text = 'Active'
        boolen = true
        break
      case false:
        text = 'Passive'
        boolen = false
        break
      case 'Active':
        text = 'Active'
        boolen = true
        break
      case 'Passive':
        text = 'Passive'
        boolen = false
        break
      case '1':
        text = 'Active'
        boolen = false
        break
      case '2':
        text = 'Inactive'
        boolen = true
        break
      case '3':
        text = 'Inactive'
        boolen = false
        break
      case '4':
        text = 'Passive'
        boolen = false
        break
      case 1:
        text = 'Active'
        boolen = true
        break
      case 2:
        text = 'Inactive'
        boolen = false
        break
      case 3:
        text = 'Inactive'
        boolen = false
        break
      case 4:
        text = 'Passive'
        boolen = false
        break
      case 'Loyalty Enabled':
        text = 'Loyalty Enabled'
        boolen = true
        break
      case 'Loyalty Disabled':
        text = 'Loyalty Disabled'
        boolen = false
        break
    }

    return {boolen, text}
  }

  const yesOrNoCheck = (input: any) => {
    const activeTex = 'Yes'
    const passiveText = 'No'

    let text = passiveText
    let boolen = true

    switch (input) {
      case true:
        text = activeTex
        boolen = true
        break
      case false:
        text = passiveText
        boolen = false
        break
      case 1:
      case '1':
        text = activeTex
        boolen = true
        break
      case 0:
      case '0':
      case 2:
      case '2':
        text = passiveText
        boolen = false
        break
    }

    return {boolen, text}
  }

  const phoneRender = (input: any) => {
    if (!input) return ''

    if (input?.includes('+')) {
      return input
    } else {
      const newInput =
        '+971 ' + input?.slice(0, 2) + ' ' + input?.slice(2, 5) + ' ' + input?.slice(5)
      return newInput
    }
  }

  const valueSelectsCheck = (input: any, selects: any) => {
    if (input?.length > 0) {
      const selecteds = selects?.filter((select) => input?.includes(select.value))
      const text = selecteds?.map((select) => select.text).join(', ')
      return {
        boolen: true,
        text,
      }
    }

    let boolen = true

    const selected = selects?.find((select) => select.value === input)
    boolen = selected?.value === 0

    return {
      boolen,
      text: selected?.text || '',
    }
  }

  const formInput = (column: ColumnType, index?: number) => {
    const name = column.formName || column.dataIndex

    /*     if (column.key === 'workingDays') {
      const dayVal = Number(column.dataIndex)
      return (
        <div className='row align-items-center'>
          <div className='col-md-auto'>
            <Field
              name={name}
              type='checkbox'
              className='form-check-input'
              checked={values.workingDays?.includes(dayVal)}
              onChange={(e) => {
                if (e.target.checked) {
                  if (!values.workingDays?.includes(dayVal)) {
                    setFieldValue('workingDays', [...values?.workingDays, dayVal])
                  }
                } else {
                  setFieldValue(
                    'workingDays',
                    values.workingDays?.filter((day) => day !== dayVal)
                  )
                }
              }}
            />
            <label className='form-check-label ms-3'>
              {values.workingDays?.includes(dayVal) ? 'Active' : 'Off'}
            </label>
          </div>
        </div>
      )
    }
   */

    switch (column.edit) {
      case 'input':
        return (
          <Field
            name={name}
            onChange={(e) => {
              let value =
                column.key === 'FirstName' || column.key === 'LastName'
                  ? isValidString(e.target.value)
                  : column.key === 'Email'
                  ? isValidMail(e.target.value)
                  : e.target.value
              setFieldValue(name, value)
            }}
            type='text'
            className='form-control w-50'
            // maxLength={51}
            {...(column.maxLength && {maxLength: column.maxLength})}
          />
        )
      case 'textarea':
        return (
          <Field
            name={name}
            as='textarea'
            rows={3}
            className='form-control w-75 resize-none'
            onChange={(e) => {
              setFieldValue(name, e.target.value)
            }}
            {...(column.maxLength && {maxLength: column.maxLength})}
          />
        )
      case 'input_number':
        return (
          <Field
            name={name}
            type='text'
            className='form-control w-50'
            onKeyPress={(event) => {
              if (!/[0-9.-]/.test(event.key)) {
                event.preventDefault()
              }
            }}
          />
        )
      case 'input_regex':
        return (
          <Field
            name={name}
            type='text'
            className='form-control w-50'
            onKeyPress={(event) => {
              const regex = new RegExp(escapeRegExp(column.regex || ''))
              if (regex.test(event.key)) {
                event.preventDefault()
              }
            }}
          />
        )
      case 'select':
        let selectList = column.selects?.map((select) => ({
          value: select.value,
          label: select.text,
          disabled: select?.disabled || false,
        }))

        let selectValue = selectList?.find((select) => select?.value === dataSource?.[name])
        const isSeasonSelect = column.dataIndex === 'seasonPeriod'

        return (
          <Select
            className='custom-select inline-table-select'
            options={selectList}
            isOptionDisabled={(option) => option.disabled}
            // value={selectValue}
            defaultValue={selectValue}
            components={{
              IndicatorSeparator: () => null,
            }}
            onChange={(e) => {
              if (column.setSelectedCategoryID) {
                column.setSelectedCategoryID(e?.value)
              }

              if (column.onChange) {
                column.onChange(e?.value)
              }

              setFieldValue(name, e?.value)

              if (isSeasonSelect) {
                setFieldValue('seasonStartDate', '0001-01-01T00:00:00.000Z')
                setFieldValue('seasonEndDate', '0001-01-01T00:00:00.000Z')
              }
            }}
          />
          // <>
          //   <select
          //     name={name}
          //     // type='select'
          //     // as='select'
          //     className='form-control form-select w-50'
          //     value={dataSource[name]}
          //     onChange={(e) => setFieldValue(name, e.target.value)}
          //   >
          //     {selectList?.map((select) => (
          //       <option key={select.value} value={select.value}>{select.label} {select.value}</option>
          //     ))}
          //   </select>
          // </>
        )
      case 'multiple_select':
        const isSubCategory = column.dataIndex === 'subCategoryIDs'

        let selectMultiListSubCategory = column.selects?.map((select: any) => ({
          value: select.value,
          label: select.text,
          merchantCategoryID: select.merchantCategoryID,
          merchantCategoryName: select.merchantCategoryName,
        }))

        let selectMultiList = column.selects?.map((select) => ({
          value: select.value,
          label: select.text,
        }))

        let selectMultiValue = dataSource?.[name]?.map((value: any) =>
          selectMultiList?.find((select) => select?.value == value)
        )
        if (!isSubCategory) {
          return (
            <Select
              isMulti
              // value={selectValue}
              defaultValue={selectMultiValue}
              hideSelectedOptions={false}
              closeMenuOnSelect={false}
              className='custom-select inline-table-select'
              options={selectMultiList}
              onChange={(e) => {
                if (column.setSelectedCategoryID) {
                  column.setSelectedCategoryID(e?.map((item: any) => item.value))
                }

                setFieldValue(
                  name,
                  e?.map((item: any) => item.value)
                )
              }}
              /*        components={{
                ValueContainer: ({children, ...props}) => (
                  // @ts-ignore
                  <components.ValueContainer {...props}>
                    <div className='d-flex'>{children}</div>
                  </components.ValueContainer>
                ),
              }} */
            />
          )
        } else
          return (
            <Select
              id='subCategoryIDs'
              name='subCategoryIDs'
              isMulti
              components={{
                GroupHeading: ({children, ...props}) => (
                  // @ts-ignore
                  <components.GroupHeading {...props}>
                    <span className='fw-bold text-primary border-bottom pb-2 fs-7'>{children}</span>
                  </components.GroupHeading>
                ),
                Option: ({children, ...props}) => (
                  // @ts-ignore
                  <components.Option {...props}>
                    <span className='pl-10 ms-3'>{children}</span>
                  </components.Option>
                ),
                MultiValueContainer: ({children, ...props}) => (
                  // @ts-ignore
                  <components.MultiValueContainer {...props}>
                    <div className='d-flex align-items-center'>{children}</div>
                  </components.MultiValueContainer>
                ),
              }}
              closeMenuOnSelect={false}
              options={
                selectMultiListSubCategory &&
                selectMultiListSubCategory.reduce((acc: any[], item) => {
                  const group = acc.find((g) => g.label === item.merchantCategoryName)
                  if (group) {
                    group.options.push({
                      value: item.value,
                      label: item.label,
                    })
                  } else {
                    acc.push({
                      label: item.merchantCategoryName,
                      options: [{value: item.value, label: item.label}],
                    })
                  }
                  return acc
                }, [])
              }
              className='custom-select'
              onChange={(e: any) => {
                setFieldValue(
                  'subCategoryIDs',
                  e.map((item: any) => item.value)
                )
              }}
              value={selectMultiListSubCategory
                ?.filter((item) => values.subCategoryIDs?.includes(item.value))
                ?.map((item) => ({value: item.value, label: item.label}))}
            />
          )
      case 'date':
        const isDisabledSeasonal =
          (column?.dataIndex === 'seasonStartDate' || column?.dataIndex === 'seasonEndDate') &&
          !values?.seasonPeriod

        return (
          <>
            <Flatpickr
              className='form-control w-50'
              disabled={isDisabledSeasonal}
              value={
                isDisabledSeasonal
                  ? ''
                  : dataSource?.[column?.dataIndex] === '0001-01-01T00:00:00.000Z'
                  ? null
                  : dataSource?.[column?.dataIndex]
              }
              // {...(dataSource[column.dataIndex] === '0001-01-01T00:00:00.000Z' && {defaultDate: new Date()})}
              defaultDate={new Date()}
              onChange={(date) => setFieldValue(name, date[0])}
              options={{
                dateFormat: 'd/m/Y',
                minDate:
                  column?.dataIndex === 'seasonStartDate' || column?.dataIndex === 'seasonEndDate'
                    ? new Date().setHours(0, 0, 0, 0)
                    : null,
              }}
            />
          </>
        )
      case 'time':
        return (
          <>
            <Flatpickr
              className='form-control w-50'
              value={dataSource?.[column.dataIndex]}
              placeholder='Select Time'
              // options={{ enableTime: true, noCalendar: true, dateFormat: "H:i" }}
              onChange={(date) => {
                const time = moment(date[0]).format('HH:mm')
                setFieldValue(name, time)
              }}
              options={{
                enableTime: true,
                noCalendar: true,
                time_24hr: true,
                dateFormat: 'H:i',
              }}
            />
          </>
        )
      case 'time-working-hours':
        return (
          <div className='d-flex gap-5 w-50'>
            <Flatpickr
              className='form-control w-50'
              value={values.workingHourList?.[column.dataIndex]?.workingStartHour}
              placeholder='Start Time'
              // options={{ enableTime: true, noCalendar: true, dateFormat: "H:i" }}
              onChange={(date) => {
                let time = moment(date[0]).format('HH:mm')
                setFieldValue(`workingHourList.[${column.dataIndex}].workingStartHour`, time)
              }}
              options={{
                enableTime: true,
                noCalendar: true,
                time_24hr: true,
                dateFormat: 'H:i',
              }}
            />
            <Flatpickr
              className='form-control w-50'
              value={values.workingHourList?.[column.dataIndex]?.workingEndHour}
              placeholder='End Time'
              // options={{ enableTime: true, noCalendar: true, dateFormat: "H:i" }}
              onChange={(date) => {
                let time = moment(date[0]).format('HH:mm')
                setFieldValue(`workingHourList.[${column.dataIndex}].workingEndHour`, time)
              }}
              options={{
                enableTime: true,
                noCalendar: true,
                time_24hr: true,
                dateFormat: 'H:i',
              }}
            />
          </div>
        )
      case 'country':
        const selectedCountry = list.countries?.find((country) => country.id === values.countryID)
        const _selectedCountry = {
          value: selectedCountry?.id,
          label: selectedCountry?.name,
        }

        if (column.displayType === 'text') {
          return (
            <span className='fw-bold fs-6 text-gray-800'>
              {selectedCountry?.name || 'United Arab Emirates'}
            </span>
          )
        }

        return (
          <>
            <Select
              name={name}
              id={name}
              className='custom-select w-50'
              options={list?.countries?.map((country) => ({
                value: country.id,
                label: country.name,
              }))}
              onChange={(e) => setFieldValue(name, e?.value)}
              value={_selectedCountry}
              defaultValue={_selectedCountry}
            />
          </>
        )
      case 'city':
        const selectedCity = list.cities?.find((city) => city.id === values.cityID)
        const _selectedCity = {
          value: selectedCity?.id,
          label: selectedCity?.name,
        }
        return (
          <Select
            name={name}
            id={name}
            className='custom-select w-50'
            options={list?.cities?.map((city, index) => ({
              value: city.id,
              label: city.name,
            }))}
            onChange={(e) => {
              setFieldValue(name, e?.value)
              setFieldValue('regionId', '')
            }}
            value={_selectedCity}
            defaultValue={_selectedCity}
          />
        )
      case 'region':
        const selectedRegion = list.regions?.find(
          (region) => region.id === values.regionID || region.id === values.regionId
        )
        const _selectedRegion = {
          value: selectedRegion?.id,
          label: selectedRegion?.name,
        }

        return (
          <>
            <Select
              name={name}
              id={name}
              className='custom-select w-50'
              options={list?.regions?.map((region) => ({
                value: region.id,
                label: region.name,
              }))}
              onChange={(e) => setFieldValue(name, e?.value)}
              value={_selectedRegion}
              defaultValue={_selectedRegion}
            />
          </>
        )
    }
  }

  if (isLoading) return <div>Loading...</div>

  return (
    <div style={{position: 'relative'}}>
      {loading && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(255, 255, 255, 0.5)',
            zIndex: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          Loading...
        </div>
      )}
      <div className='row'>
        {columns?.map((column, index) => {
          return (
            <div className={`col-md-${12 / columns.length}`} key={index}>
              {column?.map((col, index) => {
                /*      if (col.key === 'workingDays') {
                  return (
                    <div className='row mb-7 align-items-center' key={index}>
                      <label
                        className='col-lg-4 fw-semibold text-muted'
                        style={{
                          opacity: col.title === 'hidden' ? 0 : 1,
                        }}
                      >
                        {col.title === 'hidden' ? ' ' : col.title}
                      </label>

                      <div className='col-lg-8'>
                        {col.edit && editable ? (
                          <>
                            {formInput(col, index)}
                            {errors[col.dataIndex] && touched[col.dataIndex] && (
                              <div className='fv-plugins-message-container'>
                                <div className='fv-help-block'>{errors[col.dataIndex]}</div>
                              </div>
                            )}
                          </>
                        ) : (
                          <div className='d-flex align-items-center gap-3'>
                            <Field
                              name={col.dataIndex}
                              type='checkbox'
                              className='form-check-input'
                              checked={values.workingDays?.includes(Number(col.dataIndex))}
                            />
                            <label className='form-check-label ms-3'>
                              {values.workingDays?.includes(Number(col.dataIndex))
                                ? 'Active'
                                : 'Off'}
                            </label>
                          </div>
                        )}
                      </div>
                    </div>
                  )
                } */
                return (
                  <div className='row mb-7 align-items-center' key={index}>
                    <label
                      className={`col-lg-4 fw-semibold text-muted `}
                      style={{
                        opacity: col.title === 'hidden' ? 0 : 1,
                      }}
                    >
                      {/* {col.title} */}

                      <span className={`${col.required && 'required'}`}>
                        {col.title}
                        {col.tooltip && (
                          <span className='position-relative'>
                            <OverlayTrigger
                              placement='top'
                              overlay={<Tooltip>{col.tooltip}</Tooltip>}
                            >
                              <i className='bi bi-info-circle text-primary ms-1'></i>
                            </OverlayTrigger>
                          </span>
                        )}
                      </span>
                    </label>

                    <div className='col-lg-8'>
                      {col.edit && editable ? (
                        <>
                          {col.edit === 'phone' ? (
                            <div>
                              {/*   <InputMask
                                mask={'+\\9\\7\\1\\ 99 999 9999'}
                                name={col.formName || col.dataIndex}
                                className='form-control w-50'
                                value={values[col.formName || col.dataIndex]}
                                onChange={(e) => {
                                  setFieldValue(col.dataIndex, e.target.value)
                                }}
                                onClick={() => {
                                  setTouched({...touched, [col.dataIndex]: true})
                                }}
                                onBlur={() => {
                                  setTouched({...touched, [col.dataIndex]: true})
                                }}
                              /> */}

                              <PhoneNumberInput
                                values={values}
                                setFieldValue={setFieldValue}
                                setTouched={setTouched}
                                colName={col.dataIndex}
                              />

                              {errors[col.dataIndex] && touched[col.dataIndex] && (
                                <div className='fv-plugins-message-container'>
                                  <div className='fv-help-block'>{errors[col.dataIndex]}</div>
                                </div>
                              )}
                            </div>
                          ) : (
                            <>
                              {formInput(col)}
                              {errors[col.dataIndex] && touched[col.dataIndex] && (
                                <div className='fv-plugins-message-container'>
                                  <div className='fv-help-block'>{errors[col.dataIndex]}</div>
                                </div>
                              )}
                            </>
                          )}
                        </>
                      ) : (
                        <span className='fw-bold fs-6 text-gray-800'>
                          {col.render ? (
                            col.render(dataSource?.[col?.dataIndex], col)
                          ) : col.status ? (
                            <span
                              className={`badge badge-light-${
                                statusCheck(dataSource?.[col?.dataIndex]).boolen
                                  ? 'success'
                                  : 'danger'
                              } fw-bolder`}
                            >
                              {statusCheck(dataSource?.[col?.dataIndex]).text}
                            </span>
                          ) : col.valueSelect ? (
                            <span
                              className={`badge badge-light-${
                                valueSelectsCheck(dataSource[col.dataIndex], col?.selects || [])
                                  .boolen
                                  ? 'success'
                                  : 'danger'
                              } fw-bolder text-wrap text-start`}
                            >
                              {
                                valueSelectsCheck(dataSource[col.dataIndex], col?.selects || [])
                                  .text
                              }
                            </span>
                          ) : col.yesOrNo ? (
                            <span
                              className={`badge badge-light-${
                                yesOrNoCheck(dataSource?.[col?.dataIndex])?.text === 'Yes'
                                  ? 'success'
                                  : 'danger'
                              } fw-bolder`}
                            >
                              {yesOrNoCheck(dataSource?.[col?.dataIndex])?.text}
                            </span>
                          ) : col.edit === 'time-working-hours' ? (
                            <>
                              <span>
                                {dataSource?.workingHourList?.[col.dataIndex]?.workingStartHour &&
                                dataSource?.workingHourList?.[col.dataIndex]?.workingStartHour
                                  ? `${
                                      dataSource?.workingHourList?.[col.dataIndex]?.workingStartHour
                                    } - ${
                                      dataSource?.workingHourList?.[col.dataIndex]?.workingEndHour
                                    }`
                                  : 'No Service'}
                              </span>
                            </>
                          ) : col.edit === 'phone' ? (
                            phoneRender(dataSource?.[col?.dataIndex])
                          ) : col?.dataIndex && dataSource?.[col?.dataIndex] ? (
                            dataSource?.[col?.dataIndex]
                          ) : (
                            ''
                          )}
                        </span>
                      )}
                    </div>
                  </div>
                )
              })}
            </div>
          )
        })}
      </div>
    </div>
  )
}
